module.exports = __webpack_public_path__ + "static/014-4f2d886816154fcae4a8e1e248cc66d4.jpg";